import { useState } from "react";
import { Link } from "react-router-dom";
import { guCategories } from "@/mocks/categories";
import { guEvents } from "@/mocks/events";
import EventCard from "@/components/feature/EventCard";

export default function CategoryBrowse() {
  const [active, setActive] = useState("all");
  const filtered = active === "all" ? guEvents : guEvents.filter((e) => e.category === active);

  return (
    <section id="topics" className="scroll-mt-24 border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-bold tracking-[0.25em] text-primary-600">
              BROWSE BY TYPE
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              按类型翻瓜田
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              不同类型的事件，评论区的风向也完全不同。想看价格翻车还是情感复盘，点标签直接切。
            </p>
          </div>
          <Link
            to="/topics"
            className="inline-flex w-fit shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            全部专题列表
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {guCategories.map((cat) => (
            <button
              key={cat.key}
              type="button"
              onClick={() => setActive(cat.key)}
              className={`flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                active === cat.key
                  ? "bg-foreground-950 text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-700 hover:border-foreground-400 hover:text-foreground-950"
              }`}
            >
              <i className={`${cat.icon} text-base`} />
              {cat.label}
            </button>
          ))}
        </div>

        <p className="mt-4 text-xs text-foreground-500">
          {guCategories.find((c) => c.key === active)?.desc}
        </p>

        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((event, index) => (
            <EventCard key={event.id} event={event} index={index} />
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="mt-6 rounded-lg border border-dashed border-background-300 bg-background-50 py-14 text-center">
            <i className="ri-ghost-line text-3xl text-foreground-400" />
            <p className="mt-3 text-sm text-foreground-600">这个分类暂时没有新瓜，换个类型看看。</p>
          </div>
        )}
      </div>
    </section>
  );
}